import { useTranslation } from "react-i18next";

import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

/**
 * Marker for settings whose new value is persisted immediately but only
 * takes effect on the next API restart. The tooltip carries the
 * explanation; the badge itself is short enough to fit beside the row.
 */
export function RequiresRestartBadge() {
  const { t } = useTranslation("admin-settings");
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            variant="outline"
            tabIndex={0}
            aria-label={t("row.requiresRestart")}
            data-testid="requires-restart-badge"
            className="cursor-help"
          >
            {t("row.requiresRestart")}
          </Badge>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="max-w-xs text-xs leading-relaxed"
          data-testid="requires-restart-tooltip"
        >
          {t("row.requiresRestartTip")}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
